import React from "react";

const CustomProgressBar = ({ progress }) => {
    const progressBarStyle = {
        width: `${progress}%`,
    };

    return (
        <div className="custom-progress-bar">
            <div className="progress" style={progressBarStyle}></div>
        </div>
    );
};

export default CustomProgressBar;



